import styled, { CSSProperties } from 'styled-components';
import { beam } from '@styles/colors/themes';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';

interface DateDivProps {
  $width: CSSProperties['width'];
  height?: number;
  borderColor?: string;
  pinnedData?: boolean;
}
export const DateDiv = styled.div<DateDivProps>`
  font-family: 'Poppins', sans-serif;

  .MuiButtonBase-root {
    position: absolute;
    left: ${({ pinnedData }) => (pinnedData ? '4px' : 'unset')};
    right: ${({ pinnedData }) => (pinnedData ? 'unset' : '4px')};
  }
  .MuiInputBase-input {
    padding: 0 12px 0 16px;
    height: ${({ height }) => height || '42'}px;
    height: ${({ pinnedData }) => pinnedData && '32'}px;
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid ${({ borderColor }) => borderColor || COLORS_FLAT.n400};
  }
  .MuiInputAdornment-positionEnd {
    position: absolute;
    right: 0;
  }
  & .MuiInputBase-root {
    display: flex;
    align-items: center;
    font-family: 'Poppins', sans-serif;
    height: ${({ height }) => height || '42'}px;
    height: ${({ pinnedData }) => pinnedData && '32'}px;
    margin-right: ${({ pinnedData }) => pinnedData && '-8px'};
    font-size: 14px;
    color: ${beam.font.primary};
    background: transparent;
    box-sizing: border-box;
    & .MuiInputBase-input {
      display: flex;
      font-size: 14px;
      justify-items: center;
      justify-content: center;
    }
    & .MuiSvgIcon-root {
      height: 18px;
      width: 18px;
    }
  }

  & .MuiFormHelperText-root.Mui-error {
    position: absolute;
    bottom: -18px;
    margin-left: 10px;
    color: transparent;
  }
  & .MuiIconButton-root {
    color: ${COLORS_FLAT.n800};
  }
  & .Mui-disabled {
    &.MuiIconButton-root,
    &.MuiInputBase-input {
      color: #8f95b2;
      border-color: ${({ borderColor }) => borderColor || COLORS_FLAT.n200};
    }
    &.MuiInputBase-input {
      background-color: #f5f7fb;
    }
  }
`;
DateDiv.displayName = 'DateDiv';
